import { apiClient } from '@/lib/api-client';

export type TaxCategory = 'GRAVADO' | 'EXONERADO' | 'INAFECTO' | 'EXPORTACION' | 'GRATUITO';

export interface Product {
  id: string;
  tenantId: string;
  sku: string;
  name: string;
  description: string | null;
  unitCode: string;
  taxCategory: TaxCategory;
  price: string;
  trackInventory: boolean;
  imageUrl: string | null;
  active: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface ProductListResponse {
  items: Product[];
  total: number;
  page: number;
  pageSize: number;
}

export interface ProductInput {
  sku: string;
  name: string;
  description?: string | null;
  unitCode: string;
  taxCategory: TaxCategory;
  price: number;
  trackInventory: boolean;
  imageUrl?: string | null;
  active: boolean;
}

export interface ProductListParams {
  page?: number;
  pageSize?: number;
  search?: string;
  active?: boolean;
}

export async function listProducts(params: ProductListParams = {}): Promise<ProductListResponse> {
  const { data } = await apiClient.get<ProductListResponse>('/products', { params });
  return data;
}

export async function createProduct(input: ProductInput): Promise<Product> {
  const { data } = await apiClient.post<Product>('/products', input);
  return data;
}

export async function updateProduct(id: string, input: Partial<ProductInput>): Promise<Product> {
  const { data } = await apiClient.patch<Product>(`/products/${id}`, input);
  return data;
}

export async function deleteProduct(id: string): Promise<void> {
  await apiClient.delete(`/products/${id}`);
}
